function validate(obj) {
    var _isValid = true;
    var fiealds = obj.find(".required-field");

    fiealds.each(function (i) {
        if(!$(this).val()){
            $(this).parent(".form-group").addClass("has-error");
            _isValid = false;
        }
    })

    return _isValid;
}